import { IOfferScopePageLang } from '../../../types/lang'

export const offerScopePageLang: IOfferScopePageLang = {
	offer_scope_page: {
		notification_unscoped_offers_count: '{{cnt}} offers_ua',
		notification_unscoped_offers_title: 'are unscoped_ua',
		btn_add_new: 'Add New_ua',
	}
}